module.exports = __webpack_public_path__ + "static/media/Mekansm.921e5f06.png";